import { render, staticRenderFns } from "./FormAsideNew.vue?vue&type=template&id=95923e88&scoped=true&"
import script from "./FormAsideNew.vue?vue&type=script&lang=js&"
export * from "./FormAsideNew.vue?vue&type=script&lang=js&"
import style0 from "./FormAsideNew.vue?vue&type=style&index=0&id=95923e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95923e88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VFileInput,VForm,VSelect,VTextField})
